// extracted by mini-css-extract-plugin
export default {"VitalCard":"Nir_VitalCard__znM92","Half":"Nir_Half__9rw3y","nirInput":"Nir_nirInput__lVVO0"};